// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/*
 * jQuery File Upload Plugin CSS
 * https://github.com/blueimp/jQuery-File-Upload
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */

.fileinput-button {
    display: inline-block;
    overflow: hidden;
    position: relative;
}

.fileinput-button input {
    -ms-filter: 'alpha(opacity=0)';
    cursor: pointer;
    direction: ltr;
    font-size: 200px !important;
    margin: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
}

/* Fixes for IE < 8 */

@media screen\\9 {
    .fileinput-button input {
        filter: alpha(opacity=0);
        font-size: 100%;
        height: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./assets/jquery.fileupload/css/jquery.fileupload.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;;;;;;;;;EASE;;AAEF;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,2BAA2B;IAC3B,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA,qBAAqB;;AAErB;IACI;QACI,wBAAwB;QACxB,eAAe;QACf,YAAY;IAChB;AACJ","sourcesContent":["@charset \"UTF-8\";\r\n\r\n/*\r\n * jQuery File Upload Plugin CSS\r\n * https://github.com/blueimp/jQuery-File-Upload\r\n *\r\n * Copyright 2013, Sebastian Tschan\r\n * https://blueimp.net\r\n *\r\n * Licensed under the MIT license:\r\n * http://www.opensource.org/licenses/MIT\r\n */\r\n\r\n.fileinput-button {\r\n    display: inline-block;\r\n    overflow: hidden;\r\n    position: relative;\r\n}\r\n\r\n.fileinput-button input {\r\n    -ms-filter: 'alpha(opacity=0)';\r\n    cursor: pointer;\r\n    direction: ltr;\r\n    font-size: 200px !important;\r\n    margin: 0;\r\n    opacity: 0;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n}\r\n\r\n/* Fixes for IE < 8 */\r\n\r\n@media screen\\9 {\r\n    .fileinput-button input {\r\n        filter: alpha(opacity=0);\r\n        font-size: 100%;\r\n        height: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
